import React, { FC, useState } from 'react';
import {
  withStyles,
  TextField,
  WithStyles,
  createStyles,
} from '@material-ui/core';
import api from '../../services/ApiInstance';
import ApiRoutes from '../../services/ApiRoutes';
import { toast } from 'react-toastify';
import AddEntityDialog from '../dialog/AddEntityDialog';
import LocalComboBox from '../combobox/local-combo-box';

const styles = createStyles({
  formControl: {
    marginBottom: 10,
  },
});

interface Props extends WithStyles<typeof styles> {
  names: string[];
  entityType: number;
  onAdd: () => void;
}

const AddAliasDialog: FC<Props> = ({ names, entityType, classes, onAdd }) => {
  const [name, setName] = useState(names.length > 0 ? names[0] : '');
  const [alias, setAlias] = useState('');

  const resetForm = () => {
    setAlias('');
  };

  const validate = () => {
    if (!name || !alias) {
      return { valid: false };
    }
    if (name.toLowerCase() === alias.toLowerCase()) {
      return { valid: false, text: 'Name and Alias must be different' };
    }
    return { valid: true };
  };

  const addAlias = async () => {
    const aliasMap = {
      entityType,
      name,
      aliases: [alias],
    };
    await api.post(ApiRoutes.saveAlias, aliasMap);
    toast.success('Alias added');
    onAdd();
  };

  return (
    <AddEntityDialog
      buttonName="Add Alias"
      title="Add Alias"
      validateFunc={validate}
      addFunc={addAlias}
      onClose={() => resetForm()}
    >
      <LocalComboBox
        options={names}
        value={name}
        onChange={(_: any, value: string) => setName(value)}
        customLabel="Name *"
        className={classes.formControl}
      />
      <TextField
        value={alias}
        required
        variant="outlined"
        label="Alias"
        fullWidth
        onChange={(e) => setAlias(e.target.value.trim())}
        className={classes.formControl}
      />
    </AddEntityDialog>
  );
};

export default withStyles(styles)(AddAliasDialog);
